import { AdminPage } from "./AdminPage";
import { RegistrationPage } from "./RegistrationPage";
import { ConsultationPage } from "./ConsultationPage";
import { lazy, Suspense } from "react";

const CheckinPage = lazy(() => import("./CheckinPage").then((module) => ({ default: module.CheckinPage })));

export function App() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path === "/admin") return <AdminPage />;
  if (path === "/consulta") return <ConsultationPage />;
  if (path === "/checkin") return <Suspense fallback={<main className="checkin-login-shell"><section className="checkin-login-card">Preparando o check-in…</section></main>}><CheckinPage /></Suspense>;
  if (path !== "/") {
    return <main className="not-found"><h1>Página não encontrada</h1><a href="/">Voltar para a inscrição</a></main>;
  }
  return <RegistrationPage />;
}
